import { Text } from '@mxenabled/mxui'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

export interface LegendProps {
  average?: string
  color: string
  legendLabelAvg?: string
  legendLabelMain?: string
  legendStyle?: SxProps
}

export const Legend = ({
  average,
  color,
  legendLabelAvg,
  legendLabelMain,
  legendStyle = {},
}: LegendProps) => (
  <Stack
    sx={{
      alignItems: 'center',
      flexDirection: 'row',
      gap: 16,
      justifyContent: 'flex-end',
      width: '100%',
      ...legendStyle,
    }}
  >
    {legendLabelMain && (
      <Stack alignItems="center" flexDirection="row" gap={8}>
        <svg
          aria-hidden="true"
          aria-labelledby="chartLegendLabel"
          fill="none"
          height="6"
          role="figure"
          width="7"
        >
          <rect fill={color} height="6" rx="2" width="6" x="0.4375" />
        </svg>
        <Text id="chartLegendLabel" sx={{ fontSize: 11, fontWeight: 400 }} variant="caption">
          {legendLabelMain}
        </Text>
      </Stack>
    )}

    {average && legendLabelAvg && (
      <Stack alignItems="center" flexDirection="row" gap={8}>
        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
          }}
        >
          {[...Array(3)].map((_, i) => (
            <Box
              key={i}
              sx={{
                width: 3,
                height: 3,
                borderRadius: 4,
                backgroundColor: 'secondary.lighter',
              }}
            />
          ))}
        </Stack>
        <Text sx={{ fontSize: 11, fontWeight: 400, ml: 0 }} variant="caption">
          {legendLabelAvg}: {average}
        </Text>
      </Stack>
    )}
  </Stack>
)
